import React, { useContext } from "react";
import { Path } from "paths";
import {
  SupplyItemList,
  CreateSupplyItem,
  SupplyItemSummary,
  SupplyItemMovement,
  EditSupplyItem,
  StocktakeList,
  CreateStocktake,
  StocktakeDetails,
  StockTransfers,
} from "modules";
import { RouteRender } from "components/commons";
import { useFlags } from "launchdarkly-react-client-sdk";
import { setPageTitle } from "services";
import { useMount } from "hooks";
import ImportSupplyItems from "modules/inventory/import-supply-item";
import { VenueContext } from "contexts";
import { isOdooSupplyItemLocked } from "services/venue.service";

const InventoryPage = () => {
  const flags = useFlags();
  const { stocktake, supplyItems } = flags;
  const { venue } = useContext(VenueContext);
  // A locked venue creates and edits supply items in Odoo and has no Stocktake, so a typed-in
  // URL is sent back to the list instead of to a form the BE rejects. These are redirects rather
  // than dropped routes: "supply-item/create" would otherwise match "supply-item/:id".
  const supplyItemLocked = isOdooSupplyItemLocked(venue);
  const showStocktake = stocktake && !supplyItemLocked;
  const lockedRedirect = supplyItemLocked ? { redirectTo: Path.INVENTORY_SUPPLY_ITEM } : {};

  useMount(() => {
    setPageTitle("inventory");
  });

  return (
    <RouteRender
      defaultRedirect={Path.INVENTORY_SUPPLY_ITEM}
      renders={{
        [Path.CREATE_STOCKTAKE]: {
          exact: true,
          component: CreateStocktake,
          featureFlag: showStocktake,
        },
        [Path.CREATE_SUPPLY_ITEM]: {
          exact: true,
          component: CreateSupplyItem,
          featureFlag: supplyItems,
          ...lockedRedirect,
        },
        [Path.IMPORT_SUPPLY_ITEM]: {
          exact: true,
          component: ImportSupplyItems,
          featureFlag: supplyItems,
          ...lockedRedirect,
        },
        [Path.EDIT_SUPPLY_ITEM_PAGE]: {
          exact: true,
          component: EditSupplyItem,
          featureFlag: supplyItems,
          ...lockedRedirect,
        },
        [Path.SUPPLY_ITEM_MOVEMENT]: {
          exact: true,
          component: SupplyItemMovement,
          featureFlag: supplyItems,
        },
        [Path.SUPPLY_ITEM_SUMMARY]: {
          exact: true,
          component: SupplyItemSummary,
          featureFlag: supplyItems,
        },
        [Path.INVENTORY_SUPPLY_ITEM]: {
          exact: true,
          component: SupplyItemList,
          featureFlag: supplyItems,
        },
        [Path.INVENTORY_STOCKTAKE]: {
          exact: true,
          component: StocktakeList,
          featureFlag: showStocktake,
        },
        [Path.STOCKTAKE_PAGE]: {
          exact: true,
          component: StocktakeDetails,
          featureFlag: showStocktake,
        },
        [Path.INVENTORY_STOCK_TRANSFERS]: {
          exact: true,
          component: StockTransfers,
        },
      }}
    />
  );
};

export default InventoryPage;
